import React from 'react';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  { q: "How do I sync my existing Jira/Linear tasks?", a: "Go to System Config > Integrations. LaunchLayer bi-directionally syncs with major dev tools to map technical readiness to your launch board." },
  { q: "Is this demo using real-time data?", a: "This is a simulated command environment using high-fidelity dummy datasets to showcase the 'Mission Control' workflow without exposing private data." },
  { q: "Can I invite external PR agencies to the Asset Room?", a: "Yes. Use the 'Squad' settings to grant 'Asset Only' permission to external partners for secure review and upload." },
  { q: "What defines a 'Stage Gate'?", a: "A Stage Gate is a hard dependency that requires manual authorization from a designated Commander before the sequence can proceed to the next phase." },
  { q: "Does LaunchLayer handle automated social posting?", a: "Our 'Comms Relays' connect to your social stack. Posts are queued and triggered automatically only after the final 'Ignition' gate is authorized." },
  { q: "How is LaunchLayer priced for enterprise teams?", a: "We offer seat-based licensing for active squads. Contact our mission desk for a custom deployment quote." },
];

const Support = () => {
  return (
    <div className="max-w-3xl mx-auto space-y-12 pb-20">
      <div className="text-center space-y-4">
        <h2 className="text-3xl font-bold text-ice">Support Hub</h2>
        <p className="text-slate-400 font-mono text-sm uppercase tracking-widest">Knowledge Base & System FAQ</p>
      </div>

      <div className="space-y-6">
        {faqs.map((faq, i) => (
          <div key={i} className="glass-panel p-6 rounded-2xl border border-slate-800">
            <h4 className="text-ice font-bold mb-3 flex items-start">
              <span className="text-rocket-500 mr-3 font-mono">Q:</span>
              {faq.q}
            </h4>
            <p className="text-slate-400 text-sm leading-relaxed pl-7">
              {faq.a}
            </p>
          </div>
        ))}
      </div>

      <div className="bg-slate-900 border border-slate-800 p-8 rounded-2xl text-center space-y-4">
        <SafeIcon name="MessageSquare" className="mx-auto text-rocket-500 text-3xl" />
        <h3 className="text-ice font-bold">Still need help?</h3>
        <p className="text-sm text-slate-500">Our mission support team is available 24/7 for Enterprise commanders.</p>
        <button className="bg-ice text-slate-950 px-6 py-2 rounded font-bold text-sm hover:bg-rocket-500 hover:text-white transition-all">
          Open Support Ticket
        </button>
      </div>
    </div>
  );
};

export default Support;